import {Routes} from "@angular/router";
import {AuthenticationGuard, AuthorizationGuard} from "@softline/auth";
import {aktivitaetStepGuard} from './guards/aktivitaet-step.guard';
import {kontrolleStepGuard} from './guards/kontrolle-step.guard';
import {SOFTLINE_PERMISSION_PRUEFPROTOKOLL} from './pruefprotokoll.shared';

export const pruefprotokollRoutes: Routes = [
  {
    path: 'pruefprotokoll',
    loadComponent: () => import('./pages/pruefprotokoll.component').then(o => o.PruefprotokollComponent),
    loadChildren: () => [
      {
        path: 'abfrage',
        loadComponent: () =>
          import('./pages/abfrage/abfrage.component').then(
            (o) => o.AbfrageComponent
          ),
      },
      {
        path: 'ergebnis',
        loadComponent: () =>
          import('./pages/ergebnis-liste/ergebnis-liste.component').then(
            (o) => o.ErgebnisListeComponent
          ),
      },
      {
        path: 'erstellen',
        loadComponent: () => import('./pages/erstellen/erstellen.component').then(c => c.ErstellenComponent),
        loadChildren: () => [
          {
            path: 'lagerplatz',
            loadComponent: () =>
              import('./pages/erstellen/lagerplatz-scannen/lagerplatz-scannen.component').then(
                (o) => o.LagerplatzScannenComponent
              ),
          },
          {
            path: 'aktivitaet-auswaehlen',
            canActivate: [aktivitaetStepGuard],
            loadComponent: () =>
              import('./pages/erstellen/aktivitaet-auswaehlen/aktivitaet-auswaehlen.component').then(
                (o) => o.AktivitaetAuswaehlenComponent
              ),
          },
          {
            path: 'kontrolle',
            canActivate: [kontrolleStepGuard],
            loadComponent: () =>
              import('./pages/erstellen/kontrolle/kontrolle.component').then(
                (o) => o.KontrolleComponent
              ),
          }
        ]
      },
      {
        path: '**',
        redirectTo: '/pruefprotokoll/erstellen/lagerplatz'
      }
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_PRUEFPROTOKOLL },
  },
];
